import { combineReducers } from 'redux';
import currentUserReducer from './currentUser';
import notificationsReducer from './notifications';
import loadingReducer from './loading';
import ApprovalsReducer from './approvals';
import StagesReducer from './stages';
import StreamboxesReducer from './streamboxes';

const rootReducer = combineReducers({
    currentUser: currentUserReducer,
    notifications: notificationsReducer,
    loading: loadingReducer,
    approvals: ApprovalsReducer,
    stages: StagesReducer,
    streamboxes: StreamboxesReducer,
});

export default rootReducer;
